import { render, staticRenderFns } from "./ConfirmationCredential.vue?vue&type=template&id=65dbe7da&"
import script from "./ConfirmationCredential.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCredential.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65dbe7da')) {
      api.createRecord('65dbe7da', component.options)
    } else {
      api.reload('65dbe7da', component.options)
    }
    module.hot.accept("./ConfirmationCredential.vue?vue&type=template&id=65dbe7da&", function () {
      api.rerender('65dbe7da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Company/Modal/ConfirmationCredential.vue"
export default component.exports